

export default {
    name: "EllipsisTooltip",
    props: {
        text: {
            type: [String, Number],
            default: "",
        },
        // hover的提示内容，一但设置这个值，就算内容不溢出也会显示tooltip
        tooltipText: {
            type: [String, Number],
            default: "",
        },
        lines: {
            type: [String, Number],
            default: 1,
            validator: (value) => value > 0,
        },
        // 是否可以点击
        clickEnable: {
            type: Boolean,
            default: false,
        },
        /**
         * 是否增加popperClass
         */
        isAddPopperClass: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOverflow: false,
        };
    },
    computed: {
        contentStyle() {
            return {
                WebkitLineClamp: this.lines,
                lineClamp: this.lines,
                cursor: this.clickEnable ? "pointer" : "default",
                color: this.clickEnable ? "#3C76DD" : "",
            };
        },
    },
    watch: {
        text() {
            this.$nextTick(this.checkOverflow);
        },
        lines() {
            this.$nextTick(this.checkOverflow);
        },
    },
    mounted() {
        this.checkOverflow();
    },
    methods: {
        getTooltipContent() {
            if (this.tooltipText) {
                return this.tooltipText;
            }
            return this.text;
        },
        checkOverflow() {
            const el = this.$refs.content;
            if (!el) return;
            if (this.tooltipText) {
                // 如果设置了tooltipText，则直接认为内容溢出
                this.isOverflow = true;
                return;
            }

            // 判断是否溢出 , 加4是补全border占位的误差
            this.isOverflow = el.scrollHeight > el.clientHeight + 4;
            // // 获取元素的计算样式
            // const computedStyle = window.getComputedStyle(el);
            // // 解析行高为整数，使用10进制
            // const lineHeight = parseInt(computedStyle.lineHeight, 10);
            // // 解析webkitLineClamp属性或使用默认行数，也转换为整数，使用10进制
            // const lines = parseInt(computedStyle.webkitLineClamp || this.lines, 10);
            // // 计算期望的高度，即行高乘以行数
            // const expectedHeight = lineHeight * lines;
            // // 判断元素的实际滚动高度是否大于期望的高度，以确定是否溢出
            // this.isOverflow = el.scrollHeight > expectedHeight;
        },
        handleMouseenter() {
            // 防止内容变化后未及时更新
            this.checkOverflow();
        },
        // 触发点击事件
        handleClick() {
            if (this.clickEnable) {
                this.$emit("click");
            }
        },
    },
    filters: {
    },
};
